<template>
	<promo-sales-timed>
		<template slot-scope="{ phasesInfo: { currentPhase, annualSalesPhases, timeZone } }">
			<promo-sale-phase-2
				:current-phase="currentPhase"
				:phases="annualSalesPhases"
				:time-zone="timeZone"
			/>
		</template>
	</promo-sales-timed>
</template>

<script>
import PromoSalesTimed from "@/components/promo-sales-timed";
import PromoSalePhase2 from "./promo-sale-phase-2";

export default {
	name: "AnnualSale2020Banner",
	components: {
		PromoSalesTimed,
		PromoSalePhase2,
	}
};
</script>